define([
    'jQuery',
    'moment',
    'library/fcse-component/optionsMixin',
    'library/fcse-logging/log',
    'jquery.cookie'
], function($, moment, OptionsMixin, Log) {

    /**
     * Tracks and stores changed search params for user search
     * @param options
     * @constructor
     */
    var UserSearchPrefill = function(options) {

        var defaultOptions = {
            trackedParams: ['departureAirports', 'departureDate', 'returnDate', 'duration', 'travellers', 'groupNames'],
            arrayParams: ['departureAirports', 'groupNames'],
            arraySeparator: ';'
        };

        this.addOptions(defaultOptions, options);

        this._scope = null;
        this._version = '1';
    };

    UserSearchPrefill.prototype = $.extend({}, OptionsMixin, {
        /**
         * Registers the scope so that scope changes will be tracked
         *
         * @param scope
         */
        registerScope: function(scope){
            this._scope = scope;
            scope.change($.proxy(this._onScopeChange, this));
        },

        /**
         * Scope change handler
         *
         * @param scope
         * @param params
         * @private
         */
        _onScopeChange: function(scope, params){
            var self = this;
            var paramsToTrack = [];

            $.each(scope.changedParams, function(idx, paramName) {
                if ($.inArray(paramName, self.option('trackedParams')) !== -1) {
                    paramsToTrack.push(paramName);
                }
            });

            if (paramsToTrack.length) {
                this._updateParams(paramsToTrack, params);
            }
        },

        /**
         * Updates params
         * @param paramNames
         * @param values
         * @private
         */
        _updateParams: function(paramNames, values) {
            var storedValue = this.getPrefillValue();
            var paramName;

            for (var i = 0; i < paramNames.length; i++) {
                paramName = paramNames[i];
                if ($.inArray(paramName, this.option('arrayParams')) !== -1) {
                    storedValue[paramName] = values[paramName].join(this.option('arraySeparator'));
                } else {
                    storedValue[paramName] = values[paramName];
                }
            }

            this.setPrefillValue(storedValue);
        },

        /**
         * Returns storage name.
         * We can bump storage with new version if e.g. structure is changed
         * @returns {string}
         * @private
         */
        _getStorageName: function() {
            return 'uprefill' + this._version;
        },
        /**
         * Logs error in debug env
         * @param e
         * @private
         */
        _logError: function(e) {
            if (!this._log) {
                this._log = new Log();
            }
            this._log.error(e);
        },

        /**
         * Returns current prefill value
         * @returns {*|{}}
         */
        getPrefillValue: function() {
            var rawValue = $.cookie(this._getStorageName());
            var result = null;

            if (rawValue) {
                try {
                    // We use own data encoding to avoid any issues with manipulating
                    // global $.cookie.json / $.cookie.raw in other libs usage.
                    result = JSON.parse(decodeURIComponent(rawValue));
                } catch(e) {
                    this._logError(e);
                }
            }
            return result || {};
        },

        /**
         * Stores prefill value
         * @param value
         */
        setPrefillValue: function(value) {
            if (!$.isPlainObject(value)) {
                this._logError('Value is not an object');
            }
            var rawValue = encodeURIComponent(JSON.stringify(value));
            var expires = 1;

            if (value.departureDate) {
                var now = moment();
                expires = moment(value.departureDate, 'YYYY-MM-DD').diff(now, 'days');
            }

            $.cookie(this._getStorageName(), rawValue, { path: '/', expires: expires });
        }
    });

    return UserSearchPrefill;
});


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/usersearchprefill/userSearchPrefillTracker.js